import { Card, CardContent, FormHelperText, Typography } from "@mui/material";
import type { ChartDataset } from "chart.js";
import React, { useMemo } from "react";
import { backgroundColors } from "../../../utils/charts.ts";
import BarsVertical from "../../charts/BarsVertical.tsx";

export default function PatientEncounters({
  data,
}: {
  data: Partial<DeviceSearchResponse>;
}) {
  const { models } = data;
  const [datasets, labels] = useMemo(() => {
    if (!models) {
      const datasets: ChartDataset<"bar", number[]>[] = [
        {
          label: "Patient Records",
          data: [0, 0],
          backgroundColor: backgroundColors[0],
        },
      ];
      const labels = datasets.map((data) => data.label || "");
      return [datasets, labels];
    }
    const patientCount = models.map((pCount) => pCount.patientCount);
    const datasets = [
      {
        label: "Patient Records",
        data: patientCount,
        backgroundColor: backgroundColors[0],
      },
    ];
    const labels = models.map((model) => model.model);
    return [datasets, labels];
  }, [models]);

  return (
    <div id={"version-model-breakdown"} className="model-patient-container">
      <Typography variant="h6" align="left" gutterBottom>
        Version/Model # Breakdown
      </Typography>
      <Card>
        <CardContent>
          <div className="model-patient-container-graph">
            <BarsVertical labels={labels} datasets={datasets} />
          </div>
          <FormHelperText className="helper-text">
            Breakdown of total patient count by device version/model number.
            Some patients may have multiple devices used within the same index
            procedure.
          </FormHelperText>
        </CardContent>
      </Card>
    </div>
  );
}
